/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Chart_Stock_InInputs */

const vi_report_chart_stock_in = /** @type {(inputs: Report_Chart_Stock_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập kho`)
};

/**

* @param {Report_Chart_Stock_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_chart_stock_in = /** @type {((inputs?: Report_Chart_Stock_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Chart_Stock_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_chart_stock_in(inputs)
});